import { InvoiceVoucherDetail } from './invoice-voucher-detail.model';

export class InvoiceVoucherProcessModel extends InvoiceVoucherDetail {
    public WorkflowId: number;
}